import {Injectable} from '@angular/core';
import { PopupControl } from 'src/app/models/popup-control.model';
import { NavigationStart, Router } from '@angular/router';
import { FiltersGroupSettings } from '../models/filters-group-settings.model';

@Injectable({
	providedIn: 'root',
})
export class FiltersGroupsSettingsPopUpService {

	public popupControl: PopupControl = new PopupControl(
		{
			width: '80%',
			height: '80%',
		}
	);

	public filtersGroupsSettings: FiltersGroupSettings[] = [];

	public addFiltersGroupSettings(filtersGroupSettings: FiltersGroupSettings): void {
		if (this.filtersGroupsSettings.find((item) => item.filtersOperatorId === filtersGroupSettings.filtersOperatorId)) {
			return;
		}

		this.filtersGroupsSettings.push(filtersGroupSettings);
	}

	public reset(): void {
		this.popupControl.options.title = null;
		this.popupControl.description = null;

		this.filtersGroupsSettings = [];
	}

	constructor(
		private _router: Router,
	) {
		this._router.events.subscribe(
			(event: any) => {
				if (event instanceof NavigationStart) {
					this.reset();
				}
			}
		);
	}
}
